<template>
    <div>
        <ul class="flex text-center">
            <li class="w-1/7" v-for="(weekday, index) in weekdays" :key="index">{{ weekday }}</li>
        </ul>
        <div v-if="today" class="relative z-0">
            <calendar-week
                class=""
                v-for="(startWeekDay, index) in calendarWeeks"
                :key="getWeekIndex(index)"
                :week-index="getWeekIndex(index)"
                :start-week-day="startWeekDay">
            </calendar-week>

            <div class="md:border md:border-solid md:border-gray-700 absolute h-full w-full top-0 left-0 z-10"></div>
        </div>
    </div>
</template>

<script>
import CalendarWeek from '@/components/partials/account/my-delivery-schedule/calendar/CalendarWeek';

export default {
    name: 'Calendar',
    components: {
        CalendarWeek,
    },
    data() {
        return {
            key: 0,
        };
    },
    mounted() {
        this.$store.commit('scheduledOrder/resetSelectedDeliveryDays');
    },
    watch: {
        holidays() {
            this.key > 2 ? this.key-- : this.key++;
        },
        'subscription.id'() {
            this.$store.dispatch('scheduledOrder/resetScheduledOrders');
            this.$store.dispatch('scheduledOrder/fetchAllScheduledOrders', true);
        },
    },
    methods: {
        getWeekIndex(index) {
            if (this.key > 1) {
                return `${index}-${this.key}`;
            }

            return index + '';
        },
    },
    computed: {
        calendarWeeks() {
            if (this.today === null) {
                return [];
            }
            return Array.from(Array(5).keys()).map((value) => {
                return this.$moment(this.today).clone().startOf('isoWeek').add(value, 'weeks');
            });
        },
        holidays() {
            return this.$store.getters['scheduledOrder/getHolidays'];
        },
        selectedDelivery() {
            return this.$store.getters['scheduledOrder/getSelectedDelivery'];
        },
        subscription() {
            return this.$store.getters['subscription/getActiveSubscription'];
        },
        today() {
            return this.$store.getters['scheduledOrder/getToday'];
        },
        weekdays() {
            return this.$t('CALENDAR_WEEKDAYS').split(',');
        },
    },
};
</script>
